import React from 'react';
import { Grid } from '@mui/material';
import { AssessmentOutcomePreview } from '../../AssessmentOutcomePreview';
import { useOutcomeBuilderContext } from '../state/hooks/OutcomeBuilderContext';

export const OutcomePreview = () => {
    const { getAssessmentOutcome, assessment } = useOutcomeBuilderContext();
    const outcome = getAssessmentOutcome();

    return (
        <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item sm={10} md={7} lg={7} xl={8}>
                <AssessmentOutcomePreview outcome={outcome} assessment={assessment} />
            </Grid>
        </Grid>
    );
};
